/**
 * CustomerProvisioning-SpecsCatalog.js
 *
 * State-level dataset catalog for the Customer Provisioning tool.
 * Each entry describes the available test forms, procedures,
 * comprehension records, example projects, bid-tab files, and
 * the comprehension-file name for a single state DOT.
 */

module.exports = {
  al: {
    code: 'AL',
    name: 'Alabama',
    testForms: 109,
    testProcedures: 123,
    comprehensionRecords: 2809,
    exampleProjects: 10,
    bidTabFiles: 53,
    comprehensionFile: 'aldot_2026_create.json',
  },
  ar: {
    code: 'AR',
    name: 'Arkansas',
    testForms: 19,
    testProcedures: 0,
    comprehensionRecords: 189,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'ardot_2026_create.json',
  },
  az: {
    code: 'AZ',
    name: 'Arizona',
    testForms: 10,
    testProcedures: 0,
    comprehensionRecords: 4225,
    exampleProjects: 10,
    bidTabFiles: 2,
    comprehensionFile: 'adot_2026_create.json',
  },
  ca: {
    code: 'CA',
    name: 'California',
    testForms: 21,
    testProcedures: 0,
    comprehensionRecords: 187,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'CALTRANS_2026_create.json',
  },
  co: {
    code: 'CO',
    name: 'Colorado',
    testForms: 6,
    testProcedures: 0,
    comprehensionRecords: 174,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'CDOT_2026_create.json',
  },
  ct: {
    code: 'CT',
    name: 'Connecticut',
    testForms: 16,
    testProcedures: 0,
    comprehensionRecords: 185,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'CTDOT_2026_create.json',
  },
  de: {
    code: 'DE',
    name: 'Delaware',
    testForms: 81,
    testProcedures: 0,
    comprehensionRecords: 271,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'DELDOT_2026_create.json',
  },
  fl: {
    code: 'FL',
    name: 'Florida',
    testForms: 138,
    testProcedures: 0,
    comprehensionRecords: 262,
    exampleProjects: 0,
    bidTabFiles: 3,
    comprehensionFile: 'FDOT_2026_create.json',
  },
  ga: {
    code: 'GA',
    name: 'Georgia',
    testForms: 7,
    testProcedures: 0,
    comprehensionRecords: 624,
    exampleProjects: 10,
    bidTabFiles: 4,
    comprehensionFile: 'gdot_2026_create.json',
  },
  hi: {
    code: 'HI',
    name: 'Hawaii',
    testForms: 5,
    testProcedures: 0,
    comprehensionRecords: 206,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'HDOT_2026_create.json',
  },
  ia: {
    code: 'IA',
    name: 'Iowa',
    testForms: 51,
    testProcedures: 0,
    comprehensionRecords: 238,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'IADOT_2026_create.json',
  },
  il: {
    code: 'IL',
    name: 'Illinois',
    testForms: 53,
    testProcedures: 0,
    comprehensionRecords: 311,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'IDOT_2026_create.json',
  },
  in: {
    code: 'IN',
    name: 'Indiana',
    testForms: 28,
    testProcedures: 119,
    comprehensionRecords: 4784,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'indot_2026_create.json',
  },
  ks: {
    code: 'KS',
    name: 'Kansas',
    testForms: 9,
    testProcedures: 0,
    comprehensionRecords: 289,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'KDOT_2026_create.json',
  },
  ky: {
    code: 'KY',
    name: 'Kentucky',
    testForms: 20,
    testProcedures: 0,
    comprehensionRecords: 211,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'kytc_2026_create.json',
  },
  la: {
    code: 'LA',
    name: 'Louisiana',
    testForms: 163,
    testProcedures: 89,
    comprehensionRecords: 0,
    exampleProjects: 0,
    bidTabFiles: 5,
    comprehensionFile: null,
  },
  ma: {
    code: 'MA',
    name: 'Massachusetts',
    testForms: 7,
    testProcedures: 0,
    comprehensionRecords: 188,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MASSDOT_2026_create.json',
  },
  md: {
    code: 'MD',
    name: 'Maryland',
    testForms: 12,
    testProcedures: 0,
    comprehensionRecords: 246,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'MDSHA_2026_create.json',
  },
  me: {
    code: 'ME',
    name: 'Maine',
    testForms: 29,
    testProcedures: 0,
    comprehensionRecords: 167,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MEDOT_2026_create.json',
  },
  mi: {
    code: 'MI',
    name: 'Michigan',
    testForms: 60,
    testProcedures: 0,
    comprehensionRecords: 264,
    exampleProjects: 10,
    bidTabFiles: 2,
    comprehensionFile: 'MIDOT_2026_create.json',
  },
  mn: {
    code: 'MN',
    name: 'Minnesota',
    testForms: 35,
    testProcedures: 0,
    comprehensionRecords: 212,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MNDOT_2026_create.json',
  },
  mo: {
    code: 'MO',
    name: 'Missouri',
    testForms: 60,
    testProcedures: 0,
    comprehensionRecords: 177,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MODOT_2026_create.json',
  },
  ms: {
    code: 'MS',
    name: 'Mississippi',
    testForms: 11,
    testProcedures: 0,
    comprehensionRecords: 212,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'msdot_2026_create.json',
  },
  nc: {
    code: 'NC',
    name: 'North Carolina',
    testForms: 128,
    testProcedures: 0,
    comprehensionRecords: 220,
    exampleProjects: 0,
    bidTabFiles: 3,
    comprehensionFile: 'NCDOT_2026_create.json',
  },
  ne: {
    code: 'NE',
    name: 'Nebraska',
    testForms: 49,
    testProcedures: 0,
    comprehensionRecords: 255,
    exampleProjects: 10,
    bidTabFiles: 2,
    comprehensionFile: 'NDOR_2026_create.json',
  },
  nj: {
    code: 'NJ',
    name: 'New Jersey',
    testForms: 47,
    testProcedures: 0,
    comprehensionRecords: 213,
    exampleProjects: 0,
    bidTabFiles: 2,
    comprehensionFile: 'NJDOT_2026_create.json',
  },
  nm: {
    code: 'NM',
    name: 'New Mexico',
    testForms: 6,
    testProcedures: 0,
    comprehensionRecords: 208,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'NMDOT_2026_create.json',
  },
  nv: {
    code: 'NV',
    name: 'Nevada',
    testForms: 3,
    testProcedures: 0,
    comprehensionRecords: 172,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'NVDOT_2026_create.json',
  },
  ny: {
    code: 'NY',
    name: 'New York',
    testForms: 154,
    testProcedures: 0,
    comprehensionRecords: 233,
    exampleProjects: 0,
    bidTabFiles: 2,
    comprehensionFile: 'NYSDOT_2026_create.json',
  },
  oh: {
    code: 'OH',
    name: 'Ohio',
    testForms: 33,
    testProcedures: 0,
    comprehensionRecords: 259,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'OHDOT_2026_create.json',
  },
  or: {
    code: 'OR',
    name: 'Oregon',
    testForms: 9,
    testProcedures: 0,
    comprehensionRecords: 2241,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'odot_2026_create.json',
  },
  pa: {
    code: 'PA',
    name: 'Pennsylvania',
    testForms: 4,
    testProcedures: 0,
    comprehensionRecords: 277,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'PENNDOT_2026_create.json',
  },
  sc: {
    code: 'SC',
    name: 'South Carolina',
    testForms: 9,
    testProcedures: 0,
    comprehensionRecords: 5821,
    exampleProjects: 10,
    bidTabFiles: 4,
    comprehensionFile: 'scdot_2026_create.json',
  },
  sd: {
    code: 'SD',
    name: 'South Dakota',
    testForms: 10,
    testProcedures: 0,
    comprehensionRecords: 212,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'SDDOT_2026_create.json',
  },
  tn: {
    code: 'TN',
    name: 'Tennessee',
    testForms: 57,
    testProcedures: 0,
    comprehensionRecords: 358,
    exampleProjects: 10,
    bidTabFiles: 9,
    comprehensionFile: 'tdot_2026_create.json',
  },
  tx: {
    code: 'TX',
    name: 'Texas',
    testForms: 19,
    testProcedures: 0,
    comprehensionRecords: 10726,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'txdot_2026_create.json',
  },
  ut: {
    code: 'UT',
    name: 'Utah',
    testForms: 24,
    testProcedures: 0,
    comprehensionRecords: 141,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'UDOT_2026_create.json',
  },
  va: {
    code: 'VA',
    name: 'Virginia',
    testForms: 50,
    testProcedures: 0,
    comprehensionRecords: 235,
    exampleProjects: 0,
    bidTabFiles: 2,
    comprehensionFile: 'vdot_2026_create.json',
  },
  vt: {
    code: 'VT',
    name: 'Vermont',
    testForms: 22,
    testProcedures: 0,
    comprehensionRecords: 194,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'VTRANS_2026_create.json',
  },
  wa: {
    code: 'WA',
    name: 'Washington',
    testForms: 23,
    testProcedures: 0,
    comprehensionRecords: 394,
    exampleProjects: 10,
    bidTabFiles: 3,
    comprehensionFile: 'wsdot_2026_create.json',
  },
  wv: {
    code: 'WV',
    name: 'West Virginia',
    testForms: 30,
    testProcedures: 0,
    comprehensionRecords: 226,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'wvdot_2026_create.json',
  },
  wy: {
    code: 'WY',
    name: 'Wyoming',
    testForms: 4,
    testProcedures: 0,
    comprehensionRecords: 197,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'WYDOT_2026_create.json',
  },
};
